<script setup>
import { computed } from 'vue';
import { useDateFormat } from '@vueuse/core';
const props = defineProps({
  title: {
    type: String,
    default: () => '',
  },
  id: {
    type: String,
    default: () => '',
  },
  date: {
    type: String,
    default: () => '',
  },
  url: {
    type: String,
    default: () => '',
  },
  theme: {
    type: String,
    default: () => '',
  },
});
const formattedDates = computed(() => {
  return useDateFormat(props.date, 'DD.MM.YYYY');
});
</script>
<template>
  <div
    :class="[
      `purchase purchase--${theme}`,
      theme === 'black' ? 'white' : 'black',
    ]"
  >
    <p v-if="title" :class="['purchase__title m-0 h5']" v-html="title"></p>
    <div class="purchase__info">
      <div v-if="id" class="purchase__info-item body-3-regular">
        <span class="purchase__info-item-title">{{ $t('purchases.id') }}</span>
        <span class="purchase__info-item-value">{{ id }}</span>
      </div>
      <div v-if="date" class="purchase__info-item body-3-regular">
        <span class="purchase__info-item-title">{{
          $t('purchases.announced')
        }}</span>
        <span class="purchase__info-item-value">{{ formattedDates }}</span>
      </div>
    </div>
    <Button v-slot="slotProps" as-child rounded variant="outlined">
      <CTagDetect
        :href="url"
        target="_blank"
        :class="[
          slotProps.class,
          `link-normal button-next-arrow purchase__button js-button-purchase`,
          theme === 'black' ? 'button-transparent-white' : 'button-transparent',
        ]"
      >
        {{ $t('purchases.button') }}
        <CIcon
          class="button-next-arrow__icon"
          :name="theme === 'black' ? 'external-white' : 'external-black'"
          width="16"
          height="16"
        />
      </CTagDetect>
    </Button>
  </div>
</template>
<style scoped lang="scss">
@use 'sass:math';
.purchase {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  padding: 16px;
  min-height: 192px;
  @include media-breakpoint-up(sm) {
    gap: 24px;
    padding: 24px;
    min-height: 242px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(border-radius, 8);
    @include responsive-spacing(gap, 24);
    @include responsive-spacing(padding, 24);
    @include responsive-spacing(min-height, 242);
  }
  &--white {
    background-color: $gray;
  }
  &--black {
    background-color: rgba($surface-container-opacity, 0.5);
  }
  &--gray {
    background-color: $white;
  }
  &__title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    @include media-breakpoint-up(sm) {
      -webkit-line-clamp: 3;
    }
  }
  &__info {
    &-item {
      display: flex;
      flex-direction: row;
      gap: 4px;
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(gap, 4);
      }
      &-title {
        color: $on-surface-variant-2;
      }
    }
  }
  &__button {
    margin-top: auto;
    max-width: fit-content;
  }
}
</style>
